import {
  Layout,
  Col,
  Row,
  Input,
  Image,
  Avatar,
  Divider,
  Space,
  Typography,
  Dropdown,
  Menu,
  Grid,
  InputRef,
  Button,
  Modal,
  Result,
  message,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import logo from "@assets/SVG/logo.svg";
import { Icon } from "@iconify/react";
import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "@hooks/useAuth";
import { useNavigate } from "react-router-dom";
import styles from "./Header.module.scss";
import { Roles } from "~/Utils/Roles";
import { get, put } from "@services/api.service";
import { useNotification } from "~/Hooks/useNotification";
import { imageKey, mediaHost, UserType } from "~/Utils";
import cs from "classnames";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import gpt from "~/Assets/SVG/gptSupport.svg";
import { isPanelUserActive, panelLandingRoute } from "../../../Components/ModuleSelection/moduleAccess";
import { useHasAccess } from "@hooks/useHasAccess";

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const Header = () => {
  const [searchText, setSearchText] = useState("");
  const { user, logout } = useAuth();
  const [profileDetails, setProfileDetails] = useState<any>({});
  const [nameLogo, setNameLogo] = useState<string>();
  const [allRoles, setAllRoles] = useState<any[]>();
  const [currentRole, setCurrentRole] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [, setUser] = useLocalStorage("user", {});
  const { lg, md, xs } = useBreakpoint();
  const { openToast } = useNotification();
  const navigate = useNavigate();
  const extras = useRef<HTMLDivElement>(null);
  const searchBar = useRef<InputRef>(null);
  const { hasRole } = useHasAccess();
  const [isMobile, setIsMobile] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const activePanelUsers = localStorage.getItem("inactivePanelUser");

    const handlePanelNavigation = async () => {
    /* Same live re-check as the module picker: the login-time flag goes stale
       the moment an admin activates the user in Panel Contract. */
    if (!(await isPanelUserActive())) {
      message.error("De-activated User");
      return;
    }

    navigate(panelLandingRoute());
  };

  if (!user) {
    navigate("/auth/login");
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const getRoles = () => {
  //   get(`user/fetch/user-roles`).then((res: any) => {
  //     setAllRoles(res.response.data.roles)
  //   }).catch((err: any) => {
  //     console.log(err)
  //   })
  // }

  // const getCurrentRole = () => {
  //   get(`user/fetch/current-role`).then((res: any) => {
  //     setCurrentRole(res.response.data.currentRole)
  //     if(user?.role) {
  //       setOpenModal(res.response.data.currentRole != user?.role)
  //     }
  //   }).catch((err: any) => {
  //     console.log(err)
  //   })
  // }

  // const updateCurrentRole = (changeRole: string) => {
  //   const payload = {
  //     uniqueId: "",
  //     currentRole: changeRole
  //   }
  //   put(`user/update/current-role`,payload).then((res: any) => {
  //     setUser({...user,role: changeRole})
  //     window.location.pathname = `/${UserType[changeRole as keyof typeof UserType]}-dashboard`;
  //     console.log(res)
  //   }).catch((err: any) => {
  //     console.log(err)
  //   })
  // }
  useEffect(() => {
    // // getRoles();
    // getCurrentRole();
    if ((user.email && !user.userName) || (user.role === "CLM_USER" && !user.userName)) {
      get(`v1/user/details/profile`)
        .then((res: any) => {
          if (res.response.data) {
            setUser({
              ...user,
              userLogo: res.response.data.userLogo,
              userName: res.response.data.userName,
            });
            setProfileDetails(res.response.data);
          }
        })
        .catch();
    } else if (user) {
      setProfileDetails({
        userLogo: user.userLogo,
        userName: user.userName,
      });
    }
  }, []);

  const getRole = (role: string) => {
    switch (role) {
      case Roles.SPA_USER:
        return "SPA User";
      case Roles.SPA_REVIEWER:
        return "SPA Reviewer";
      case Roles.SPA_ADMIN:
        return "SPA Admin";
      case Roles.SPA_APPROVER:
        return "SPA Approver";
      default:
        return "";
    }
  };

  if (!user) {
    navigate("/auth/login");
  }

  useEffect(() => {
    if (profileDetails?.userName) {
      const nameArray = profileDetails.userName.split(" ");
      const firstName = nameArray[0]?.charAt(0) || "";
      const lastName = nameArray.length > 1 ? nameArray[nameArray.length - 1]?.charAt(0) : "";

      const displayText = `${firstName}${lastName}`.toUpperCase();
      setNameLogo(displayText);
    }
  }, [profileDetails]);

  const logoStyle = isMobile ? { width: 100, cursor: "pointer" } : { maxWidth: 120, cursor: "pointer" };

  return (
    <Layout.Header
      className={cs(styles.header, {
        [styles.SmallHeader]: xs,
      })}
    >
      <Row
        align="middle"
        gutter={[16, 16]}
        style={{ height: "100%" }}
      >
        <Col
          span={2}
          className={styles.logoStyle}
        >
          <Image
            src={`${mediaHost}/images/branding/logo.png${imageKey}`}
            preview={false}
            style={logoStyle}
            onClick={() => {
              window.location.pathname = `${UserType[user?.role as keyof typeof UserType]}-dashboard`;
            }}
          />
        </Col>
        <Col span={3}>
          {/* <Typography.Title className={styles.flowStyle}>
            CLM - {UserType[user?.role as keyof typeof UserType]?.toUpperCase()}
          </Typography.Title> */}
        </Col>
        <Col
          span={7}
          style={{ display: "flex" }}
        ></Col>
        <Col
          span={12}
          style={{ textAlign: "right", justifyContent: "space-between" }}
        >
          <div
            className={styles.NavExtras}
            ref={extras}
            style={{
              marginLeft: "auto",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              lineHeight: 1.2,
              gap: 16,
            }}
          >
            {/* <Divider
              type="vertical"
              style={{
                borderLeft: "1px solid rgba(0, 0, 0, 0.22)",
                background: "D7D5F1",
                height: "56px",
              }}
            /> */}
            {/* <Typography.Link>
              <Icon
                icon={"clarity:bell-outline-badged"}
                style={{ margin: "auto", color: styles.strawberry }}
                height="20"
              />
            </Typography.Link> */}
            <Button
              type="primary"
              onClick={() => setOpenConfirmationModal(true)}
            >
              Workorder
            </Button>
            <Typography.Link>
              <Dropdown
                overlay={
                  <Menu>
                    {!lg && (
                      <Menu.Item
                        key="profile"
                        disabled
                      >
                        <Space
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            lineHeight: 1.3,
                            textAlign: "left",
                            alignItems: "start",
                            justifyContent: "center",
                          }}
                          size={4}
                        >
                          <Text
                            strong
                            className={styles.userName}
                            ellipsis
                          >
                            {profileDetails && profileDetails.userName}
                          </Text>
                          <Text
                            type="secondary"
                            strong={false}
                            ellipsis
                          >
                            {getRole(user?.role)}
                          </Text>
                        </Space>
                      </Menu.Item>
                    )}
                    {allRoles?.map((item: any) => {
                      return (
                        <Menu.Item
                          key={item}
                          disabled={item == currentRole}
                          // onClick={() => updateCurrentRole(item)}
                        >
                          {item == currentRole ? getRole(item) + " (In Use)" : getRole(item)}
                        </Menu.Item>
                      );
                    })}
                    <Menu.Item
                      key="logout"
                      onClick={() => logout()}
                    >
                      Logout
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Space
                  size={"small"}
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  <Text className="userNameLogo">{nameLogo}</Text>
                  {lg && (
                    <Space
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        lineHeight: 1.2,
                        textAlign: "left",
                        alignItems: "start",
                        justifyContent: "center",
                      }}
                      size={4}
                    >
                      <Text
                        strong
                        className={styles.userName}
                        ellipsis
                      >
                        {profileDetails && profileDetails.userName}
                        {/* {profileDetails.userName
                          ? profileDetails.userName
                          : user && user.email && user.email.split("@")[0]} */}
                      </Text>
                      <Text
                        type="secondary"
                        strong={false}
                        ellipsis
                      >
                        {getRole(user?.role)}
                      </Text>
                    </Space>
                  )}
                  <Icon
                    icon="ep:arrow-down-bold"
                    height="20"
                    style={{ margin: "auto", color: styles.strawberry }}
                  />
                </Space>
              </Dropdown>
            </Typography.Link>
          </div>
        </Col>
      </Row>
      <Modal
        open={openModal}
        maskClosable={false}
        centered
        footer={null}
        closable={false}
      >
        <Result
          status={"403"}
          title={"Role Update Detected!"}
          subTitle={
            <Typography.Text>
              Your role has been modified to {currentRole && getRole(currentRole)} Certain modules may now be
              inaccessible. To access your newly assigned roles, please click on “Update Role.” If you require
              assistance or clarification, kindly reach out to your administrator for support through{" "}
              <b>clmsupport@myairports.com</b>
            </Typography.Text>
          }
          extra={[
            <div style={{ gap: 10, display: "flex", justifyContent: "center" }}>
              {/* <Button
              type="primary"
              onClick={() => {
                if(currentRole) {
                  updateCurrentRole(currentRole)
                }
              }}
            >
              Update Role
            </Button> */}
              <Button
                type="ghost"
                onClick={() => {
                  if (currentRole) {
                    logout();
                  }
                }}
              >
                Logout
              </Button>
            </div>,
          ]}
        />
      </Modal>
      <Modal
        open={openConfirmationModal}
        centered
        footer={null}
        closable={false}
        maskClosable={false}
        onCancel={() => setOpenConfirmationModal(false)}
        title={<div style={{ textAlign: "center", color: "#4CAF50", fontWeight: 700, fontSize: 18 }}>Work Order</div>}
        width={340}
      >
        <div style={{ textAlign: "center", padding: "8px 0 24px" }}>
          <p style={{ fontSize: 15, marginBottom: 24 }}>Are You Sure you want to Shift to Workorder</p>
          <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
            <Button
              onClick={() => setOpenConfirmationModal(false)}
              style={{ width: 100 }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handlePanelNavigation}
              style={{ width: 100 }}
            >
              Yes
            </Button>
          </div>
        </div>
      </Modal>
    </Layout.Header>
  );
};
